"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useThrottledResizeObserver_1 = __importDefault(require("../common/hooks/useThrottledResizeObserver"));
const ActionCard_styles_1 = require("./ActionCard.styles");
const renderIcon = (icon, focused = false) => {
    if (react_1.default.isValidElement(icon) ||
        typeof icon === 'string' ||
        typeof icon === 'number') {
        return icon;
    }
    return focused ? icon.focused : icon.default;
};
/** A component for rendering small, interactive cards */
const ActionCard = react_1.default.forwardRef((_a, ref) => {
    var { id, label, children, actions = [] } = _a, rest = __rest(_a, ["id", "label", "children", "actions"]);
    const { ref: actionContainerRef, height = 0, width = 0 } = (0, useThrottledResizeObserver_1.default)({});
    const [active, setActive] = react_1.default.useState(null);
    const handleActive = (id) => {
        setActive(id);
    };
    const handleNonActive = () => {
        setActive(null);
    };
    return (react_1.default.createElement(ActionCard_styles_1.Card, Object.assign({}, rest, { id: id, ref: ref, "data-ref": ref ? 'set' : 'unset' }),
        react_1.default.createElement(ActionCard_styles_1.ActionContainer, { ref: actionContainerRef, offsetX: width, offsetY: height }, actions.map(({ id, icon, label: actionLabel, disabled, onActivate }) => (react_1.default.createElement(ActionCard_styles_1.ActionButton, { mode: "flat", "aria-label": label ? `${label}, ${actionLabel}` : actionLabel, disabled: disabled, key: id, onClick: onActivate, onMouseEnter: () => handleActive(id), onMouseLeave: () => handleNonActive(), onFocus: () => handleActive(id), onBlur: () => handleNonActive() }, renderIcon(icon, active === id))))),
        react_1.default.createElement(ActionCard_styles_1.ContentContainer, null, children)));
});
ActionCard.displayName = 'ActionCard';
exports.default = ActionCard;
//# sourceMappingURL=ActionCard.js.map